var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-176 -252)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(176 252)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.5 252.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.915,8.708c0,5.606-7.208,10.411-7.208,10.411S4.5,14.313,4.5,8.708a7.208,7.208,0,1,1,14.415,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.305,12.9a2.4,2.4,0,1,1-2.4-2.4A2.4,2.4,0,0,1,18.305,12.9Z",
    transform: "translate(-4.195 -4.195)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.c61774ce2cb3363bc6d0796ef334ed6c.svg";
export { ForwardRef as ReactComponent };